export const notifyParent = (action, data) => {
  window && window.parent && window.parent.postMessage({
    action,
    data
  },
  getTargetOrigin())
}

function getTargetOrigin () {
  let origin = ''
  try {
    origin = document.location.ancestorOrigins[0]
  } catch (err) {
    origin = '*'
  }
  return origin
}
